export default __webpack_public_path__ + "static/barlow-v4-latin-600-4a5aff18cc519ee4faf5592ae432be4a.woff";